import { IEvent } from "@Interfaces";
import { EVENT_TYPE, QUERY_PARAMS } from "@Utils";
import { IEventModule } from "../../../root/IEventModule";

export const getIsRenewBooking = ({
    urlQueryParams,
    eventData,
}: {
    urlQueryParams: IEventModule.IProps["urlQueryParams"];
    eventData: IEvent.IEventData;
}) =>
    urlQueryParams?.[QUERY_PARAMS.RENEW_BOOKING] === "true" &&
    [
        EVENT_TYPE.ONE_ON_ONE_CLASSES,
        EVENT_TYPE.GROUP_CLASSES,
        EVENT_TYPE.ROLLING_CLASSES,
    ].includes(eventData.type);
